import React from 'react';

const DateField = ({title, required, register, errors, ...props}) => {
    let reg = register || {}
    const {[reg.name]: error} = errors || {};
    return (
        <div className={register ? "padding-top" : ""}>
            <p className="text-input-label font-size-medium">
                {title}{" "}
                {required && <i className="required padding-right-smallest">*</i>}
            </p>
            <div className="field-format">
                <input {...register} {...props}/>
            </div>
            {error && <p className='text-color-red font-bold'> {error.message} </p>}
        </div>
    );
};

export default DateField;